export default __webpack_public_path__ + "c925a5d0acaa406acf49d1a68c10bf97.svg";